/* ==========================================================
   PRETTY ORGANISED
   Main site JavaScript
========================================================== */


/* ==========================================================
   PRODUCT / ROOM CARD ENTRANCE
========================================================== */

document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll(
    '.po-room-card,.po-product-card'
  );

  cards.forEach((card, i) => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(18px)';

    setTimeout(() => {
      card.style.transition =
        'opacity .55s ease, transform .55s ease';

      card.style.opacity = '1';
      card.style.transform = 'translateY(0)';
    }, 120 + i * 45);
  });
});


/* ==========================================================
   QUIZ
========================================================== */

(function () {

  const quiz = document.querySelector('[data-po-quiz]');

  if (!quiz) return;

  const steps = Array.from(
    quiz.querySelectorAll('[data-step]')
  );

  const progress = quiz.querySelector('[data-progress]');
  const result = quiz.querySelector('[data-result]');
  const title = quiz.querySelector('[data-result-title]');
  const copy = quiz.querySelector('[data-result-copy]');
  const primary = quiz.querySelector('[data-result-primary]');
  const secondary = quiz.querySelector('[data-result-secondary]');
  const retake = quiz.querySelector('[data-retake]');

  let current = 0;
  const answers = [];


  const showStep = (i) => {

    steps.forEach((s, idx) =>
      s.classList.toggle('is-active', idx === i)
    );

    if (progress) {
      progress.style.width =
        ((i + 1) / steps.length * 100) + '%';
    }

  };


  const recommendation = () => {

    const room = answers[0];
    const issue = answers[1];
    const help = answers[2];
    const location = answers[3];


    if (
      help === 'done-for-you' &&
      location === 'christchurch'
    ) {
      return {
        title: 'Book the in-home reset.',

        copy:
          'You’re in Christchurch and you want this properly handled. Start with an in-home organisation service, then add the products needed to keep the system working.',

        primary: '/pages/services',
        primaryText: 'Book Christchurch service',

        secondary: '/collections/all',
        secondaryText: 'Shop products'
      };
    }


    if (
      help === 'guided' ||
      issue === 'system' ||
      issue === 'overwhelm'
    ) {
      return {
        title: 'Start with a guided system.',

        copy:
          'You don’t just need more baskets — you need a plan. Start with a virtual organisation session or guide, then shop the exact products for your space.',

        primary: '/pages/services',
        primaryText: 'Explore guided support',

        secondary: '/collections/all',
        secondaryText: 'Shop the range'
      };
    }


    const map = {
      pantry: '/collections/pantry',
      wardrobe: '/collections/wardrobe',
      laundry: '/collections/laundry',
      'whole-home': '/collections/all'
    };


    return {
      title:
        'Start with the ' +
        (room === 'whole-home' ? 'best sellers' : room) +
        ' reset.',

      copy:
        'You’re ready for a practical first step. Pick one space, buy the right product system, and build momentum from there.',

      primary: map[room] || '/collections/all',
      primaryText: 'Shop recommended products',

      secondary: '/pages/services',
      secondaryText: 'View services'
    };

  };


  quiz.querySelectorAll('[data-answer]').forEach(btn => {

    btn.addEventListener('click', () => {

      answers[current] = btn.dataset.answer;
      current++;

      if (current < steps.length) {

        showStep(current);

      } else {

        steps.forEach(s =>
          s.classList.remove('is-active')
        );

        if (progress) {
          progress.style.width = '100%';
        }

        const rec = recommendation();

        title.textContent = rec.title;
        copy.textContent = rec.copy;

        primary.href = rec.primary;
        primary.textContent = rec.primaryText;

        secondary.href = rec.secondary;
        secondary.textContent = rec.secondaryText;

        result.hidden = false;

      }

    });

  });


  if (retake) {

    retake.addEventListener('click', () => {

      answers.length = 0;
      current = 0;

      result.hidden = true;

      showStep(0);

    });

  }

})();


/* ==========================================================
   CART DRAWER
========================================================== */

(function () {

  let FREE_SHIPPING_THRESHOLD = 25000;

  const drawer =
    document.getElementById('poCartDrawer');

  if (!drawer) return;

  /* Amounts and wording come from Theme settings (Cart drawer / Cart shipping estimate) */
  const cfg = drawer.dataset;
  function cents(value, fallback) {
    const n = parseFloat(value);
    return isNaN(n) ? fallback : Math.round(n * 100);
  }
  function txt(value, fallback) {
    return (value === undefined || value === null) ? fallback : value;
  }
  FREE_SHIPPING_THRESHOLD = cents(cfg.freeOver, 25000);
  const TIER_THRESHOLD = cents(cfg.tierOver, 10000);
  const RATE_LOW = cents(cfg.rateLow, 895);
  const RATE_MID = cents(cfg.rateMid, 1395);
  const RATE_RURAL = cents(cfg.rateRural, 1400);
  const RURAL_FREE = cents(cfg.ruralFree, 500);
  const T_FREE = txt(cfg.tFree, 'FREE');
  const T_SHIPPING = txt(cfg.tShipping, 'Shipping');
  const T_RURAL_SHIPPING = txt(cfg.tRuralShipping, 'Rural shipping');
  const T_UNLOCKED = txt(cfg.tUnlocked, 'You’ve unlocked free shipping!');
  const T_AWAY = txt(cfg.tAway, 'You’re [amount] away from free shipping');
  const T_AFTERPAY = txt(cfg.tAfterpay, 'or 4 payments of [amount] with Afterpay');
  const T_ADD = txt(cfg.tAdd, 'Add +');
  function shortMoney(c) {
    return money(c).replace(/\.00$/, '');
  }


  const itemsContainer =
    drawer.querySelector('[data-po-cart-items]');

  const emptyState =
    drawer.querySelector('[data-po-cart-empty]');

  const footer =
    drawer.querySelector('[data-po-cart-footer]');

  const subtotal =
    drawer.querySelector('[data-po-cart-subtotal]');

  const shippingCost =
    drawer.querySelector('[data-po-cart-shipping-cost]');

  const shippingLabel =
    drawer.querySelector('[data-po-shipping-label]');

  const estimatedTotal =
    drawer.querySelector('[data-po-cart-estimated-total]');

  const checkoutTotal =
    drawer.querySelector('[data-po-checkout-total]');

  const afterpay =
    drawer.querySelector('[data-po-afterpay]');

  const shippingMessage =
    drawer.querySelector('[data-po-shipping-message]');

  const shippingValue =
    drawer.querySelector('[data-po-shipping-value]');

  const shippingBar =
    drawer.querySelector('[data-po-shipping-bar]');

  const rural =
    drawer.querySelector('[data-po-rural]');

  const recommendations =
    drawer.querySelector('[data-po-cart-recommendations]');

  const recommendationsGrid =
    drawer.querySelector(
      '[data-po-cart-recommendation-items]'
    );


  /* ----------------------------------------------------------
     MONEY
  ---------------------------------------------------------- */

  function money(cents) {

    return new Intl.NumberFormat('en-NZ', {
      style: 'currency',
      currency: 'NZD'
    }).format((cents || 0) / 100);

  }


  /* ----------------------------------------------------------
     SHIPPING CALCULATOR
  ---------------------------------------------------------- */

  function calculateShipping(cartTotal, isRural) {

    /*
      $250+
      Standard = FREE
      Rural = $5 surcharge
    */

    if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
      return isRural ? RURAL_FREE : 0;
    }


    /*
      $100 – $249.99
      Standard = $13.95
      Rural = $14.00
    */

    if (cartTotal >= TIER_THRESHOLD) {
      return isRural ? RATE_RURAL : RATE_MID;
    }


    /*
      $0 – $99.99
      Standard = $8.95
      Rural = $14.00
    */

    return isRural ? RATE_RURAL : RATE_LOW;

  }


  /* ----------------------------------------------------------
     OPEN / CLOSE
  ---------------------------------------------------------- */

  function openCart() {

    drawer.classList.add('is-open');

    drawer.setAttribute('aria-hidden', 'false');

    document.body.classList.add('po-cart-open');

  }


  function closeCart() {

    drawer.classList.remove('is-open');

    drawer.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('po-cart-open');

  }


  document.addEventListener('click', function (event) {

    const openTrigger =
      event.target.closest('[data-po-cart-open]');


    if (openTrigger) {

      event.preventDefault();

      refreshCart().then(openCart);

      return;

    }


    if (
      event.target.closest('[data-po-cart-close]')
    ) {

      event.preventDefault();

      closeCart();

    }

  });


  document.addEventListener('keydown', function (event) {

    if (event.key === 'Escape') {
      closeCart();
    }

  });


  /* ----------------------------------------------------------
     GET CART
  ---------------------------------------------------------- */

  async function getCart() {

    const response =
      await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });


    if (!response.ok) {
      throw new Error('Unable to load cart');
    }


    return response.json();

  }


  /* ----------------------------------------------------------
     REFRESH CART
  ---------------------------------------------------------- */

  async function refreshCart() {

    try {

      const cart = await getCart();

      syncRuralCheckbox(cart);

      renderCart(cart);

      updateCartCount(cart.item_count);


      if (cart.items.length) {

        loadRecommendations(
          cart.items[cart.items.length - 1].product_id,
          cart
        );

      } else {

        hideRecommendations();

      }


      return cart;


    } catch (error) {

      console.error(
        'Pretty Organised cart:',
        error
      );

    }

  }


  /* ----------------------------------------------------------
     RENDER CART
  ---------------------------------------------------------- */

    function renderCart(cart) {

    /* Only count items that actually ship (digital / free guides don't) */
    const requiresShipping = !!cart.requires_shipping;

    const shippableTotal =
      cart.items
        .filter(item => item.requires_shipping)
        .reduce((sum, item) => sum + item.final_line_price, 0);


    /* Hide the free-shipping bar, rural option and shipping row when nothing ships */
    const shippingBlock = drawer.querySelector('.po-cart-shipping');
    const ruralOption = rural ? rural.closest('.po-rural-option') : null;
    const shippingRow = shippingCost ? shippingCost.closest('.po-cart-total-row') : null;

    if (shippingBlock) shippingBlock.hidden = !requiresShipping;
    if (ruralOption) ruralOption.hidden = !requiresShipping;
    if (shippingRow) shippingRow.hidden = !requiresShipping;


    updateShipping(shippableTotal);


    const attributes =
      cart.attributes || {};


    const isRural =
      requiresShipping &&
      attributes['Rural delivery'] === 'Yes';


    const calculatedShipping =
      requiresShipping
        ? calculateShipping(shippableTotal, isRural)
        : 0;


    const totalWithShipping =
      cart.total_price + calculatedShipping;


    /* SUBTOTAL */

    if (subtotal) {

      subtotal.textContent =
        money(cart.total_price);

    }


    /* SHIPPING */

    if (shippingCost) {

      shippingCost.textContent =
        calculatedShipping === 0
          ? T_FREE
          : money(calculatedShipping);

    }


    if (shippingLabel) {

      shippingLabel.textContent =
        isRural
          ? T_RURAL_SHIPPING
          : T_SHIPPING;

    }


    /* ESTIMATED TOTAL */

    if (estimatedTotal) {

      estimatedTotal.textContent =
        money(totalWithShipping);

    }


    /* CHECKOUT BUTTON TOTAL */

    if (checkoutTotal) {

      checkoutTotal.textContent =
        money(totalWithShipping);

    }


    /* AFTERPAY */

    if (afterpay) {

      const instalment =
        totalWithShipping / 4;


      afterpay.hidden = !T_AFTERPAY;
      afterpay.innerHTML =
        escapeHTML(T_AFTERPAY).replace('[amount]', '<strong>' + money(instalment) + '</strong>');

    }


    /* EMPTY CART */

    if (!cart.items.length) {

      itemsContainer.innerHTML = '';

      emptyState.hidden = false;

      footer.hidden = true;

      return;

    }


    emptyState.hidden = true;
    footer.hidden = false;


    itemsContainer.innerHTML =
      cart.items
        .map(renderCartItem)
        .join('');

  }


  /* ----------------------------------------------------------
     RENDER CART ITEM
  ---------------------------------------------------------- */

  function renderCartItem(item) {

    const image =
      item.image
        ? `
          <a href="${item.url}" class="po-cart-line__image">
            <img
              src="${item.image}"
              alt="${escapeHTML(item.product_title)}"
            >
          </a>
        `
        : '';


    const variant =
      item.variant_title &&
      item.variant_title !== 'Default Title'
        ? `
          <span class="po-cart-line__variant">
            ${escapeHTML(item.variant_title)}
          </span>
        `
        : '';


    return `
      <div
        class="po-cart-line"
        data-po-cart-line
        data-key="${item.key}"
      >

        ${image}

        <div class="po-cart-line__content">

          <div class="po-cart-line__top">

            <div>

              <a
                href="${item.url}"
                class="po-cart-line__title"
              >
                ${escapeHTML(item.product_title)}
              </a>

              ${variant}

            </div>


            <button
              type="button"
              class="po-cart-line__remove"
              data-po-remove
              data-key="${item.key}"
              aria-label="Remove ${escapeHTML(item.product_title)}"
            >
              ×
            </button>

          </div>


          <div class="po-cart-line__bottom">

            <div class="po-cart-qty">

              <button
                type="button"
                data-po-qty-minus
                data-key="${item.key}"
                data-quantity="${item.quantity}"
                aria-label="Decrease quantity"
              >
                −
              </button>

              <span>
                ${item.quantity}
              </span>

              <button
                type="button"
                data-po-qty-plus
                data-key="${item.key}"
                data-quantity="${item.quantity}"
                aria-label="Increase quantity"
              >
                +
              </button>

            </div>

            <strong>
              ${money(item.final_line_price)}
            </strong>

          </div>

        </div>

      </div>
    `;

  }


  /* ----------------------------------------------------------
     FREE SHIPPING BAR
  ---------------------------------------------------------- */

  function updateShipping(total) {

    if (
      !shippingBar ||
      !shippingMessage ||
      !shippingValue
    ) {
      return;
    }


    const percentage =
      Math.min(
        100,
        (total / FREE_SHIPPING_THRESHOLD) * 100
      );


    shippingBar.style.width =
      percentage + '%';


    if (total >= FREE_SHIPPING_THRESHOLD) {

      shippingMessage.textContent =
        T_UNLOCKED;

      shippingValue.textContent =
        T_FREE;

      shippingBar.style.width =
        '100%';

      return;

    }


    const remaining =
      FREE_SHIPPING_THRESHOLD - total;


    shippingMessage.textContent =
      T_AWAY.replace('[amount]', money(remaining));


    shippingValue.textContent =
      money(total) +
      ' / ' + shortMoney(FREE_SHIPPING_THRESHOLD);

  }


  /* ----------------------------------------------------------
     CART COUNT
  ---------------------------------------------------------- */

  function updateCartCount(count) {

    document
      .querySelectorAll('.po-cart-count')
      .forEach(element => {

        element.textContent = count;

      });

  }


  /* ----------------------------------------------------------
     AJAX ADD TO CART
  ---------------------------------------------------------- */

  document.addEventListener(
    'submit',
    async function (event) {

      const form =
        event.target.closest(
          '[data-po-product-form]'
        );


      if (!form) return;


      event.preventDefault();


      const submitButton =
        form.querySelector(
          'button[type="submit"]'
        );


      const originalText =
        submitButton
          ? submitButton.textContent
          : '';


      try {

        if (submitButton) {

          submitButton.disabled = true;

          submitButton.textContent =
            'Adding...';

        }


        const formData =
          new FormData(form);


        const response =
          await fetch('/cart/add.js', {

            method: 'POST',

            headers: {
              Accept: 'application/json'
            },

            body: formData

          });


        if (!response.ok) {

          const error =
            await response.json();


          throw new Error(
            error.description ||
            'Unable to add item'
          );

        }


        await refreshCart();

        openCart();


      } catch (error) {

        console.error(
          'Pretty Organised add to cart:',
          error
        );


        alert(
          error.message ||
          'Sorry, we couldn’t add that item to your cart.'
        );


      } finally {

        if (submitButton) {

          submitButton.disabled = false;

          submitButton.textContent =
            originalText;

        }

      }

    }
  );


  /* ----------------------------------------------------------
     QUANTITY / REMOVE
  ---------------------------------------------------------- */

  document.addEventListener(
    'click',
    async function (event) {

      const plus =
        event.target.closest(
          '[data-po-qty-plus]'
        );

      const minus =
        event.target.closest(
          '[data-po-qty-minus]'
        );

      const remove =
        event.target.closest(
          '[data-po-remove]'
        );


      if (plus) {

        const quantity =
          parseInt(
            plus.dataset.quantity,
            10
          ) + 1;


        await changeQuantity(
          plus.dataset.key,
          quantity
        );

        return;

      }


      if (minus) {

        const quantity =
          Math.max(
            0,
            parseInt(
              minus.dataset.quantity,
              10
            ) - 1
          );


        await changeQuantity(
          minus.dataset.key,
          quantity
        );

        return;

      }


      if (remove) {

        await changeQuantity(
          remove.dataset.key,
          0
        );

      }

    }
  );


  async function changeQuantity(
    key,
    quantity
  ) {

    try {

      const response =
        await fetch('/cart/change.js', {

          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body: JSON.stringify({
            id: key,
            quantity: quantity
          })

        });


      if (!response.ok) {

        throw new Error(
          'Unable to update cart'
        );

      }


      const cart =
        await response.json();


      syncRuralCheckbox(cart);

      renderCart(cart);

      updateCartCount(
        cart.item_count
      );


      if (cart.items.length) {

        loadRecommendations(
          cart.items[
            cart.items.length - 1
          ].product_id,
          cart
        );

      } else {

        hideRecommendations();

      }


    } catch (error) {

      console.error(
        'Pretty Organised quantity:',
        error
      );

    }

  }


  /* ----------------------------------------------------------
     RURAL DELIVERY
  ---------------------------------------------------------- */

  if (rural) {

    rural.addEventListener(
      'change',
      async function () {

        try {

          rural.disabled = true;


          const response =
            await fetch('/cart/update.js', {

              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',

                Accept:
                  'application/json'
              },

              body: JSON.stringify({
                attributes: {
                  'Rural delivery':
                    rural.checked
                      ? 'Yes'
                      : ''
                }
              })

            });


          if (!response.ok) {

            throw new Error(
              'Unable to update rural delivery'
            );

          }


          const cart =
            await response.json();


          syncRuralCheckbox(cart);

          renderCart(cart);

          updateCartCount(
            cart.item_count
          );


        } catch (error) {

          console.error(
            'Pretty Organised rural:',
            error
          );


        } finally {

          rural.disabled = false;

        }

      }
    );

  }


  function syncRuralCheckbox(cart) {

    if (!rural) return;


    const attributes =
      cart.attributes || {};


    rural.checked =
      attributes['Rural delivery'] ===
      'Yes';

  }


  /* ----------------------------------------------------------
     RECOMMENDATIONS
  ---------------------------------------------------------- */

  async function loadRecommendations(
    productId,
    cart
  ) {

    if (
      !productId ||
      !recommendations ||
      !recommendationsGrid
    ) {
      return;
    }


    const cartProductIds =
      new Set(
        cart.items.map(
          item => Number(item.product_id)
        )
      );


    try {

      let products = [];


      /*
        FIRST:
        Shopify related recommendations
      */

      try {

        const response =
          await fetch(
            '/recommendations/products.json' +
            '?product_id=' +
            encodeURIComponent(productId) +
            '&limit=10&intent=related'
          );


        if (response.ok) {

          const data =
            await response.json();


          products =
            data.products || [];

        }

      } catch (recommendationError) {

        console.warn(
          'Pretty Organised related recommendations:',
          recommendationError
        );

      }


      /*
        Remove:
        - cart items
        - unavailable products
      */

      products =
        products.filter(product => {

          const alreadyInCart =
            cartProductIds.has(
              Number(product.id)
            );


          const hasAvailableVariant =
            product.variants &&
            product.variants.some(
              variant => variant.available
            );


          return (
            !alreadyInCart &&
            hasAvailableVariant
          );

        });


      /*
        FALLBACK:
        Pull products from Shop All if Shopify
        hasn't returned enough recommendations.
      */

      if (products.length < 3) {

        try {

          const fallbackResponse =
            await fetch(
              '/collections/all/products.json?limit=50'
            );


          if (fallbackResponse.ok) {

            const fallbackData =
              await fallbackResponse.json();


            const fallbackProducts =
              (fallbackData.products || [])
                .filter(product => {

                  const alreadyInCart =
                    cartProductIds.has(
                      Number(product.id)
                    );


                  const alreadyRecommended =
                    products.some(
                      recommended =>
                        Number(recommended.id) ===
                        Number(product.id)
                    );


                  const hasAvailableVariant =
                    product.variants &&
                    product.variants.some(
                      variant =>
                        variant.available
                    );


                  return (
                    !alreadyInCart &&
                    !alreadyRecommended &&
                    hasAvailableVariant
                  );

                });


            products =
              products.concat(
                fallbackProducts
              );

          }

        } catch (fallbackError) {

          console.warn(
            'Pretty Organised fallback recommendations:',
            fallbackError
          );

        }

      }


      products =
        products.slice(0, 3);


      if (!products.length) {

        hideRecommendations();

        return;

      }


      recommendationsGrid.innerHTML =
        products
          .map(renderRecommendation)
          .join('');


      recommendations.hidden = false;


    } catch (error) {

      console.error(
        'Pretty Organised recommendations:',
        error
      );


      hideRecommendations();

    }

  }


  /* ----------------------------------------------------------
     RENDER RECOMMENDATION
  ---------------------------------------------------------- */

  function renderRecommendation(product) {

    const variant =
      product.variants &&
      product.variants.find(
        item => item.available
      );


    if (!variant) {
      return '';
    }


    const image =
      getProductImage(product);


    const productUrl =
      product.url ||
      (
        product.handle
          ? '/products/' + product.handle
          : '#'
      );


    return `
      <div class="po-cart-rec">

        <a
          href="${productUrl}"
          class="po-cart-rec__image"
        >

          ${
            image
              ? `
                <img
                  src="${image}"
                  alt="${escapeHTML(product.title)}"
                  loading="lazy"
                >
              `
              : ''
          }

        </a>


        <div class="po-cart-rec__copy">

          <a
            href="${productUrl}"
            class="po-cart-rec__title"
          >
            ${escapeHTML(product.title)}
          </a>


          <span>
            ${money(Number(variant.price))}
          </span>


          <button
            type="button"
            data-po-rec-add
            data-variant="${variant.id}"
          >
            ${escapeHTML(T_ADD)}
          </button>

        </div>

      </div>
    `;

  }


  function getProductImage(product) {

    if (!product) return '';


    if (
      typeof product.featured_image ===
      'string'
    ) {
      return product.featured_image;
    }


    if (
      product.featured_image &&
      product.featured_image.src
    ) {
      return product.featured_image.src;
    }


    if (
      product.images &&
      product.images.length
    ) {

      const firstImage =
        product.images[0];


      if (
        typeof firstImage ===
        'string'
      ) {
        return firstImage;
      }


      if (
        firstImage &&
        firstImage.src
      ) {
        return firstImage.src;
      }

    }


    return '';

  }


  function hideRecommendations() {

    if (!recommendations) return;


    recommendations.hidden = true;


    if (recommendationsGrid) {

      recommendationsGrid.innerHTML =
        '';

    }

  }


  /* ----------------------------------------------------------
     ADD RECOMMENDED PRODUCT
  ---------------------------------------------------------- */

  document.addEventListener(
    'click',
    async function (event) {

      const button =
        event.target.closest(
          '[data-po-rec-add]'
        );


      if (!button) return;


      const id =
        button.dataset.variant;


      if (!id) return;


      const original =
        button.textContent;


      button.disabled = true;

      button.textContent =
        'Adding...';


      try {

        const response =
          await fetch('/cart/add.js', {

            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({
              items: [
                {
                  id: Number(id),
                  quantity: 1
                }
              ]
            })

          });


        if (!response.ok) {

          const errorData =
            await response.json();


          throw new Error(
            errorData.description ||
            'Unable to add product'
          );

        }


        await refreshCart();


      } catch (error) {

        console.error(
          'Pretty Organised recommendations:',
          error
        );


        alert(
          error.message ||
          'Sorry, we couldn’t add that item.'
        );


      } finally {

        button.disabled = false;

        button.textContent =
          original;

      }

    }
  );


  /* ----------------------------------------------------------
     ESCAPE HTML
  ---------------------------------------------------------- */

  function escapeHTML(value) {

    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  }


  /* ----------------------------------------------------------
     INITIAL LOAD
  ---------------------------------------------------------- */

  refreshCart();

})();